import React from 'react';

const EFAMPhilosophy = () => {
  return (
    <section id="philosophy" className="py-20 bg-gradient-to-b from-slate-950 to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 right-0 w-[300px] h-[300px] bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-testid="philosophy-title">
            The EFAM <span className="text-cyan-400 neon-text">Philosophy</span>
          </h2>

          {/* Core Principles */}
          <div className="space-y-4 mb-8">
            <p className="text-xl text-cyan-400 font-semibold">
              Effort over perfection
            </p>
            <p className="text-lg text-gray-300">
              Do the right thing for the right reasons
            </p>
            <p className="text-lg text-gray-300">
              Always learning, ever evolving
            </p>
          </div>

          {/* Supporting Line */}
          <p className="text-gray-400 italic text-lg">
            Real transformation happens through consistency, not extremes.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EFAMPhilosophy;
